import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CertificateRecord } from 'app/library/certificate-record/models/certificate-record';
import { CertificateService } from 'app/library/certificate/services/certificate.service';
import { ModuleManagersService } from 'app/library/module-managers/services/module-managers.service';
import { Module } from 'app/library/module/models/module.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';

@Component({
    selector: 'app-certificate-dialog',
    templateUrl: './certificate-dialog.component.html',
    styleUrls: ['./certificate-dialog.component.scss'],
})
export class CertificateDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    certificateRecord: CertificateRecord;

    @Input()
    userId: string;

    @Input()
    isViewOnly: boolean = false;

    certificateForm: FormGroup;
    fileURL: string = '';
    module: Module;

    constructor(
        public dialogRef: MatDialogRef<CertificateDialogComponent>,
        private _moduleManagersService: ModuleManagersService,
        private _fb: FormBuilder,
        private _certificateService: CertificateService
    ) {
        super();
    }

    ngOnInit(): void {
        this.certificateForm = this._fb.group({
            name: [{ value: this.certificateRecord.name, disabled: true }, Validators.required],
            issueDate: [{ value: this.certificateRecord.createdAt.format('L'), disabled: true }, Validators.required],
        });

        this.module = this.certificateRecord.finalGrade ? this.certificateRecord.finalGrade?.module : this.certificateRecord.moduleUser?.module;
    }

    goToModule(module: Module): void {
        if (this.isViewOnly) {
            return;
        }

        this.dialogRef.close();
        this._moduleManagersService.goToModule(this.userId, module, 'overview');
    }

    downloadCertificate(certificateRecord: CertificateRecord): void {
        if (this.isViewOnly) {
            return;
        }

        this._certificateService.downloadFinalGradeCertificate(certificateRecord).then(() => {});
    }
}
